import { CrudAbstractModel } from "../../crud-abstract/crud-abstract.model";
import { Location } from "../../location/location.model";
import { ContainerPrices } from "../../shared/container/container-prices.model";
import { Rate } from "../rate-type";
import { LocationMapper } from "../../location/location.mapper";
import { RateMapper } from "../rate.mapper";
import { RateFlatRouteMapper } from "./rate-flat-route.mapper";
import { countryCodes } from "../../shared/countries/country-codes.const";
import { RateFlatRoute } from "./rate-flat-route.type";

export class RateFclFlatRoute extends CrudAbstractModel {
  constructor(
    public id: number,
    public discriminator: string,
    public rate: Rate,
    public originLocation: Location,
    public destinationLocation: Location,
    public currency: string,
    public comment: string,
    public internalComment?: string,
    public containers?: ContainerPrices,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getDiscriminator(): string {
    return this.discriminator;
  }

  public setId(param: number) {
    this.id = param;
  }

  public getRate(): Rate {
    return this.rate;
  }

  public getContainers(): ContainerPrices {
    return this.containers;
  }

  public get destinationCountryName(): string {
    return this.destinationLocation
      ? countryCodes[this.destinationLocation.getCountry()]
      : null;
  }

  public get originCountryName(): string {
    return this.originLocation
      ? countryCodes[this.originLocation.getCountry()]
      : null;
  }

  public getRequestParams() {
    return {
      originLocation: this.originLocation.getId(),
      destinationLocation: this.destinationLocation.getId(),
      containers: this.containers.getRequestParams(),
      currency: this.currency,
      comment: this.comment,
      internalComment: this.internalComment,
    };
  }

  public isValid(): boolean {
    return (
      !!this.originLocation && !!this.destinationLocation && !!this.currency
    );
  }

  public getClone(): RateFlatRoute {
    return RateFlatRouteMapper.map({
      id: this.getId(),
      discriminator: this.discriminator,
      rate: RateMapper.map(this.rate),
      originLocation: LocationMapper.map(this.originLocation),
      destinationLocation: LocationMapper.map(this.destinationLocation),
      currency: this.currency,
      comment: this.comment,
      internalComment: this.internalComment,
      containers: this.containers.getRequestParams(),
    });
  }
}
